import LocalStorageService from 'services/LocalStorageService'
import { KEYS } from 'utils/localStorage'
import { PATHS, PRIVATE_PATHS } from 'utils/paths'

const NON_RESUMABLE = [
  /^\/files\/upload\//,
  /^\/create-bp/,
  /^\/edit-bp\//,
  /^\/tasks\/create/,
  /^\/analytics\/(add|edit)/,
  /^\/cart\//,
  /^\/two-factor-setup/,
  /\/compliance\/setup$/,
]

export const homePathFor = user =>
  user?.type === 'user' ? PRIVATE_PATHS.portfolios : PRIVATE_PATHS.bpList

export const isResumablePath = path => {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) return false
  const pathname = path.split(/[?#]/)[0]
  if (pathname === PATHS.login) return false
  return !NON_RESUMABLE.some(pattern => pattern.test(pathname))
}

const currentPage = () => `${window.location.pathname}${window.location.search}`

export const rememberPageAtLogout = () => {
  if (!LocalStorageService.get(KEYS.token)) return
  LocalStorageService.remove(KEYS.redirectPath)
  if (window.location.pathname === PATHS.login) return
  LocalStorageService.set(KEYS.pageAtLogout, currentPage())
}

const wasOpenAtLogout = path => {
  const page = LocalStorageService.get(KEYS.pageAtLogout)
  return !!page && path.split('#')[0] === page
}

export const resumableLink = path => (isResumablePath(path) && !wasOpenAtLogout(path) ? path : null)

export const takeStoredRedirect = () => {
  const stored = LocalStorageService.get(KEYS.redirectPath)
  const link = resumableLink(stored)
  LocalStorageService.remove(KEYS.redirectPath)
  LocalStorageService.remove(KEYS.pageAtLogout)
  return link
}
